import Vue from 'vue';
import VueBodyClass from 'vue-body-class';
import { router } from './vue-router';

Vue.use(VueBodyClass, router);



// WEBPACK FOOTER //
// ./src/plugins/vue-body-class.js